{
    "CodeList_Column_Description": "Beschrijving",
    "CodeList_Column_Code": "Code",
    "CodeList_Column_Type": "Type",
    "CodeList_Column_TelSys": "Telefoonserver",
    "CodeList_Column_Partition": "Partitie",
    "CodeList_Partition_Any": "Elk",
    "CodeList_Scope_All": "Alle",
    "CodeList_Scope_ServiceWide": "Dienstverlening breed",
    "CodeList_Scope_SystemWide": "Systeembreed",
    "CodeList_Scope_Detached": "Losgemaakt",
    "CodeList_Type_All": "Alle",
    "CodeList_Type_Account": "Rekening",
    "CodeList_Type_ACD_NotAvailable": "ACD niet beschikbaar",
    "CodeList_Scope_Label": "Domein",
    "CodeList_Type_Label": "Type",
    "CodeList_Change_AnyPartitionNotSupported": "Codes in de partitie \"Any\" kunnen hier niet worden bewerkt of bekeken. Filter de lijst op een specifieke partitie om een ​​code te wijzigen of te bekijken.",
    "NAME": "CodeListLanguage"
}